import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function Desinscription() {
  const token = useSearchParams()[0].get("token");
  const [status, setStatus] = useState("idle");

  const confirm = async () => {
    setStatus("loading");
    try {
      const r = await api.post("/newsletter/unsubscribe", { token });
      setStatus(r.data.found ? "done" : "notfound");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div data-testid="page-desinscription" className="pt-40 pb-24 px-6 min-h-screen flex flex-col items-center text-center">
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-4">Newsletter culturelle</p>
      {status === "notfound" ? (
        <>
          <h1 data-testid="unsubscribe-notfound" className="font-serif text-4xl font-light text-[#1A1A1A] mb-4">Lien invalide ou déjà utilisé.</h1>
          <p className="font-body text-[#4A4A4A] mb-8 max-w-md">Si vous recevez encore la newsletter, écrivez-nous depuis la page Contact et nous vous retirerons de la liste.</p>
          <Link to="/contact" className="text-[#2C402E] font-body link-underline">Nous contacter</Link>
        </>
      ) : status === "done" ? (
        <>
          <h1 data-testid="unsubscribe-done" className="font-serif text-4xl font-light text-[#1A1A1A] mb-4">Vous êtes désinscrit(e).</h1>
          <p className="font-body text-[#4A4A4A] mb-8">Vous ne recevrez plus notre newsletter. Merci de nous avoir lus.</p>
          <Link to="/" className="text-[#2C402E] font-body link-underline">Retour à l'accueil</Link>
        </>
      ) : (
        <>
          <h1 className="font-serif text-4xl font-light text-[#1A1A1A] mb-4">Se désinscrire de la newsletter&nbsp;?</h1>
          <p className="font-body text-[#4A4A4A] mb-8 max-w-md">Vous ne recevrez plus nos nouvelles histoires, parutions et rencontres d'auteurs.</p>
          <button onClick={confirm} disabled={!token || status === "loading"} data-testid="unsubscribe-confirm-button" className="bg-[#1A1A1A] hover:bg-[#9E4735] text-[#FAF9F6] px-8 py-3 font-body text-sm transition-colors disabled:opacity-40">
            Confirmer la désinscription
          </button>
          {!token && <p className="text-xs font-body text-[#9E4735] mt-4">Lien de désinscription incomplet.</p>}
          {status === "error" && <p className="text-xs font-body text-[#9E4735] mt-4">Une erreur est survenue, veuillez réessayer.</p>}
        </>
      )}
    </div>
  );
}
